export type ViaCepResponse = {
  erro?: boolean;
  logradouro?: string;
  bairro?: string;
  localidade?: string;
  uf?: string;
  cep?: string;
};

export class ViaCepError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ViaCepError";
  }
}

export async function fetchViaCep(cepDigits: string): Promise<ViaCepResponse> {
  const digits = cepDigits.replace(/\D/g, "");
  const resp = await fetch(`https://viacep.com.br/ws/${digits}/json/`);
  if (!resp.ok) throw new Error("Falha na consulta de CEP");
  const data = (await resp.json()) as ViaCepResponse;
  if (data.erro) throw new Error("CEP não encontrado");
  return data;
}

/** Usado pelo fluxo de cartão em `/pagamento` (erros tipados). */
export async function fetchAddressByCep(
  cepDigits: string,
): Promise<ViaCepResponse> {
  try {
    return await fetchViaCep(cepDigits);
  } catch (e) {
    const msg =
      e instanceof Error ? e.message : "Não foi possível consultar o CEP.";
    throw new ViaCepError(msg);
  }
}
